var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "teaser-card", class: _vm.bemFacets }, [
    _c(
      "div",
      { staticClass: "teaser-card--mobile-header" },
      [_vm._t("header-image")],
      2
    ),
    _vm._v(" "),
    _c("div", { staticClass: "teaser-card--row", class: _vm.paneClasses }, [
      _c(
        "div",
        {
          staticClass: "teaser-card--col teaser-card--left-pane",
          on: {
            mouseover: function($event) {
              _vm.onActivatePane("left", true)
            },
            mouseleave: function($event) {
              _vm.onActivatePane("left", false)
            }
          }
        },
        [_vm._t("left-content")],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "teaser-card--col teaser-card--right-pane",
          style: _vm._f("bgImage")(_vm.backgroundRight),
          on: {
            mouseover: function($event) {
              _vm.onActivatePane("right", true)
            },
            mouseleave: function($event) {
              _vm.onActivatePane("right", false)
            }
          }
        },
        [_vm._t("right-content")],
        2
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-33e35052", { render: render, staticRenderFns: staticRenderFns })
  }
}